/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'

import Layout from './src/components/Layout'
import '@ads/front-core/locales/i18n'

export const wrapRootElement = ({ element }) => {
  return <Layout>{element}</Layout>
}
